// extracted by mini-css-extract-plugin
export default {"title":"ProfUnionsForm_title__9HI2-"};